import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import ArrowIcon from "../icons/arrowIcon";
import { fastingMenuItems } from "./constants";

import {
  Container,
  Description,
  Header,
  ItemContainer,
  Price,
  PriceOption,
  PricesWrapper,
  SectionTitleWrapper,
  Subtitle,
  TextWrapper,
  Title,
} from "./styles";

export const FastingMenu = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <Header>
        <span
          onClick={() => navigate(-1)}
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <ArrowIcon />
          <p>{t("POSNI MENI")}</p>
        </span>
      </Header>

      <Container>
        <SectionTitleWrapper>
          <p>{t("POSNI MENI")}</p>
        </SectionTitleWrapper>

        {fastingMenuItems.map((item, index) => (
          <Fragment key={`${item.title}-${index}`}>
            <ItemContainer isFirst={item.isFirst}>
              <TextWrapper isDescription={Boolean(item.description)}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    flexWrap: "wrap",
                    gap: "4px",
                  }}
                >
                  <Title>{t(item.title)}</Title>

                  {item.subtitle && (
                    <Subtitle>{item.subtitle}</Subtitle>
                  )}
                </div>

                {item.description && (
                  <Description>
                    ({t(item.description)})
                  </Description>
                )}
              </TextWrapper>

              {item.price && <Price>{item.price}</Price>}

              {item.prices && (
                <PricesWrapper>
                  {item.prices.map((option) => (
                    <PriceOption
                      key={`${item.title}-${option.size}`}
                    >
                      <span>{option.size}/</span>
                      <Price>{option.price}</Price>
                    </PriceOption>
                  ))}
                </PricesWrapper>
              )}
            </ItemContainer>
          </Fragment>
        ))}
      </Container>
    </>
  );
};